// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/forbid-prop-types */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import ApplicantDetailsForm from './ApplicantDetailsForm';

const CreditApp = ({
	applicantDetailsFormik,
	applicantEmploymentFormik,
	initialApplicantValues,
	initialEmploymentValues,
	mapsKey,
	mobileView,
	includePersonalReferences,
	includeLoanConfig,
	customOnBlurFunc,
	fieldsToHide,
	// setFinanceModalOpen,
	minDownPayment,
	maxDownPayment,
	allFieldsFullWidth,
	vehiclePrice,
	financingProgram,
}) => {
	return (
		<>
			<div className='row g-4'>
				<div className='col-12 pb-30' />
				{initialApplicantValues && initialEmploymentValues && (
					<ApplicantDetailsForm
						detailsFormik={applicantDetailsFormik}
						employmentFormik={applicantEmploymentFormik}
						isCoApplicant={false}
						mapsKey={mapsKey}
						mobileView={mobileView}
						includePersonalReferences={includePersonalReferences}
						includeLoanConfig={includeLoanConfig}
						customOnBlurFunc={customOnBlurFunc}
						fieldsToHide={fieldsToHide}
						// setFinanceModalOpen={setFinanceModalOpen}
						minDownPayment={minDownPayment}
						maxDownPayment={maxDownPayment}
						allFieldsFullWidth={allFieldsFullWidth}
						vehiclePrice={vehiclePrice}
						financingProgram={financingProgram}
					/>
				)}
				{(!initialEmploymentValues || !initialApplicantValues) && (
					<>
						<h1 className='card-title ekho-placeholder-wave h1'>
							<span className='ekho-placeholder col-6' />
						</h1>
						<br />
						<h1 className='card-title ekho-placeholder-wave h1'>
							<span className='ekho-placeholder col-11' />
						</h1>
						<br />
						<h1 className='card-title ekho-placeholder-wave h1'>
							<span className='ekho-placeholder col-12' />
						</h1>
						<br />
						<h1 className='card-title ekho-placeholder-wave h1'>
							<span className='ekho-placeholder col-10' />
						</h1>
					</>
				)}
			</div>
			<div className='col-12 pb-30' />
		</>
	);
};

CreditApp.propTypes = {
	applicantDetailsFormik: PropTypes.object.isRequired,
	applicantEmploymentFormik: PropTypes.object.isRequired,
	initialApplicantValues: PropTypes.object.isRequired,
	initialEmploymentValues: PropTypes.object.isRequired,
	mapsKey: PropTypes.string.isRequired,
	mobileView: PropTypes.bool.isRequired,
	includePersonalReferences: PropTypes.bool,
	includeLoanConfig: PropTypes.bool,
	customOnBlurFunc: PropTypes.func,
	fieldsToHide: PropTypes.array,
	// setFinanceModalOpen: PropTypes.func,
	minDownPayment: PropTypes.number.isRequired,
	maxDownPayment: PropTypes.number.isRequired,
	allFieldsFullWidth: PropTypes.bool,
	vehiclePrice: PropTypes.number,
	financingProgram: PropTypes.string,
};
CreditApp.defaultProps = {
	includePersonalReferences: false,
	includeLoanConfig: false,
	customOnBlurFunc: null,
	fieldsToHide: [],
	// setFinanceModalOpen: null,
	allFieldsFullWidth: false,
	vehiclePrice: null,
	financingProgram: null,
};

export default CreditApp;
